export default __webpack_public_path__ + "static/taskdefinition23-902cde2bcc9ea5501089fb6ed7127033.png";